<script>
import EndingFinancingTerms from '@/components/leads/settings/potentials/EndingFinancingTerms.vue'
import EndingCashPurchases from '@/components/leads/settings/potentials/EndingCashPurchases.vue'

export default {
  components: {
    'mia-ending-financing-terms': EndingFinancingTerms,
    'mia-ending-cash-purchases': EndingCashPurchases
  }
}
</script>

<template>
  <div class="space-y-16">
    <mia-ending-financing-terms />
    <mia-ending-cash-purchases />
  </div>
</template>
